// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"contentWrapper--1d1xW","content":"content--OQfpa contentWrapper--AHarZ","title":"title--1Fp8p title--3f9JQ","detail":"detail--3cIiJ contentArea--SiMDT","section":"section--VJxcr","mainContent":"mainContent--3Na8Q","sponsorContainer":"sponsorContainer--XjHBr","sponsors":"sponsors--3tVGz","individualSponsors":"individualSponsors--_SWVI","field":"field--2Y3W4 field--3-Kdn","button":"button--1OQUO button--CeyL1 calderDark--1bp9m","fieldLabel":"fieldLabel--2DbE2 calderDark--1bp9m"};


//////////////////
// WEBPACK FOOTER
// ./screens/Sponsors/styles.css
// module id = 1045
// module chunks = 2